import { type CountryCode } from "./countries"

export const VITE_GTM_IDS = import.meta.env.VITE_GTM_IDS
export const VITE_FB_PIXEL_IDS = import.meta.env.VITE_FB_PIXEL_IDS

export const VITE_API_URL = import.meta.env.VITE_API_URL
export const VITE_API_URL_2 = import.meta.env.VITE_API_URL_2

export const COUNTRY_CODE = import.meta.env.VITE_COUNTRY_CODE as CountryCode
export const TWITTER_PIXEL_ID = import.meta.env.VITE_TWITTER_PIXEL_ID
export const TELEGRAM_LINK = import.meta.env.VITE_TELEGRAM_LINK
export const TELEGRAM_CHANNEL = import.meta.env.VITE_TELEGRAM_CHANNEL
export const LIVE_CHAT_ID = import.meta.env.VITE_LIVE_CHAT_ID
